import { motion } from 'framer-motion';
import { Navbar } from './Navbar';
import { Footer } from './Footer';

export const FinancialCrimeStatement = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="financial-crime-page">
      <Navbar />
      <main className="pt-24 pb-20">
        <div className="section-container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className="label-text text-[#6B7280] block mb-4">Legal</span>
            <h1 className="heading-lg text-3xl md:text-4xl lg:text-5xl text-[#1E3A5F] mb-8">
              Financial Crime Risk Appetite Statement
            </h1>
            <p className="text-[#6B7280] mb-8">Last updated: January 2026</p>
            
            <div className="prose prose-lg max-w-4xl text-[#4B5563]">
              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">1. Statement of Intent</h2>
                <p className="mb-4">
                  Easysend is committed to maintaining the highest standards of integrity and compliance in 
                  the fight against financial crime. This statement sets out our risk appetite for financial 
                  crime risks, including money laundering, terrorist financing, sanctions violations, fraud, 
                  and bribery and corruption.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">2. Zero Tolerance</h2>
                <p className="mb-4">
                  Easysend has zero tolerance for:
                </p>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>Money laundering in any form</li>
                  <li>Terrorist financing</li>
                  <li>Sanctions evasion or violations</li>
                  <li>Bribery and corruption</li>
                  <li>Tax evasion facilitation</li>
                  <li>Fraud against our clients, partners, or the financial system</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">3. Risk-Based Approach</h2>
                <p className="mb-4">
                  We adopt a risk-based approach to managing financial crime risk, which includes:
                </p>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>Comprehensive customer due diligence proportionate to risk</li>
                  <li>Enhanced due diligence for higher-risk customers and transactions</li>
                  <li>Ongoing monitoring of customer relationships and transactions</li>
                  <li>Regular risk assessments of our products, services, and customer base</li>
                  <li>Continuous improvement of our controls and systems</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">4. Customer Risk Categories</h2>
                <p className="mb-4">
                  We categorise customers based on risk factors including:
                </p>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li><strong>Geographic risk:</strong> Countries with higher corruption or weak AML regimes</li>
                  <li><strong>Customer risk:</strong> Business type, ownership structure, PEP status</li>
                  <li><strong>Product/service risk:</strong> Complexity and potential for misuse</li>
                  <li><strong>Channel risk:</strong> Non-face-to-face relationships</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">5. Sanctions Compliance</h2>
                <p className="mb-4">
                  Easysend maintains comprehensive sanctions screening procedures covering:
                </p>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>UN Security Council sanctions</li>
                  <li>EU sanctions regimes</li>
                  <li>UK HM Treasury sanctions</li>
                  <li>US OFAC sanctions (where applicable)</li>
                  <li>Other relevant national sanctions lists</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">6. Governance and Oversight</h2>
                <p className="mb-4">
                  Our financial crime risk management framework includes:
                </p>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>Board-level oversight and accountability</li>
                  <li>Dedicated compliance and financial crime prevention team</li>
                  <li>Independent audit and assurance</li>
                  <li>Regular reporting to senior management and the Board</li>
                  <li>Ongoing training and awareness programmes</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">7. Reporting</h2>
                <p className="mb-4">
                  Easysend fulfils its reporting obligations to relevant authorities, including:
                </p>
                <ul className="list-disc pl-6 mb-4 space-y-2">
                  <li>Suspicious Activity Reports (SARs)</li>
                  <li>Regulatory notifications as required</li>
                  <li>Law enforcement cooperation</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-[#1E3A5F] mb-4">8. Contact</h2>
                <p className="mb-4">
                  For questions about our financial crime risk management, please contact{' '}
                  <a href="mailto:compliance@easysendservices.com" className="text-[#4FB3DF] hover:underline">
                    compliance@easysendservices.com
                  </a>
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
